export const stripHtml = (value) => {
  if (typeof value !== 'string') {
    return '';
  }

  const temp = document.createElement('div');
  temp.innerHTML = value;
  const text = temp.textContent || temp.innerText || '';

  return text
    .replace(/\u00a0/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
};

export const hasHtmlContent = (value) => typeof value === 'string' && /<[^>]+>/.test(value.trim());

const HTML_ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' };

export const escapeHtml = (text) => String(text ?? '').replace(/[&<>"']/g, (char) => HTML_ESCAPES[char]);

export default {
  stripHtml,
  hasHtmlContent,
  escapeHtml,
};
